<ng-container *transloco="let t; read: 'findMyAgent.results'">
  <rma-trixel [trixelImgUrl]="agent.profileListViewTrixelUrl" [trixelSourceCategory]="trixelsSourceCategory" />

  @if (showAttribution) {
    <rma-result-attribution
      class="mb-8"
      [attribution]="agent.attribution"
      [name]="agent.name"
      [rankingAttributions]="agent.rankingAttributions"
    />
  }

  <div class="rounded border border-steel-20">
    <header class="h-8">
      <rma-branded-header class="h-full rounded-t" [background]="agent.branding.backgroundColour" [logo]="agent.branding.bannerImage" />
    </header>

    <div class="grid grid-cols-1 space-y-4 p-4 md:grid-cols-2 md:space-y-0 lg:grid-cols-3">
      <section class="mr-12 space-y-4">
        <rma-result-profile
          [avatar]="agent.branding.avatarImage"
          [name]="agent.name"
          [agencyName]="agent.agencyName"
          [starRating]="agent.overallStats.averageStarRating ?? 0"
          [totalReviews]="agent.overallStats.totalReviewCount ?? 0"
          [showRatingSummary]="true"
        />

        <ng-container *ngTemplateOutlet="contactTemplate; context: { $implicit: 'space-y-4 hidden md:flex flex-col' }" />
      </section>
      <section class="space-y-4 lg:col-span-2">
        <div>
          @if (activeLocality !== overallValue) {
            <div class="text-heading-3">
              {{ t('performance.title', { location: locality.label }) }}
            </div>
          } @else {
            <div class="text-heading-3">{{ t('performance.overall-title') }}</div>
          }

          <div class="text-sm text-steel-80">{{ t('performance.sub-title', { name: agent.shortName }) }}</div>
        </div>

        <mat-button-toggle-group
          class="w-full md:w-fit"
          [formControl]="localityControl"
          [hideSingleSelectionIndicator]="true"
          (valueChange)="seletedLocality.emit($event)"
        >
          <mat-button-toggle class="w-full min-w-[50%] md:!px-4" [value]="locality.value" data-id="your-suburb">{{
            locality.label.length > 13 ? t('your-suburb') : locality.label
          }}</mat-button-toggle>
          <mat-button-toggle class="w-full min-w-[50%] md:!px-4" [value]="overallValue" data-id="all-suburbs">{{
            t('overall')
          }}</mat-button-toggle>
        </mat-button-toggle-group>

        <dl class="grid grid-cols-2 lg:grid-cols-3">
          @for (stat of stats; track stat) {
            <div>
              <dt class="mb-2 flex items-center text-3xl font-bold">
                <rma-icon class="mr-2" [glyph]="stat.icon" />
                @if (stat.isCurrency) {
                  <span>
                    {{ stat.value | shortNumber: ((stat.value ?? 0 > 1_000_000) ? 1 : 0) : true }}
                  </span>
                } @else {
                  <span>{{ stat.value | number: '1.0-0' }}</span>
                }
              </dt>
              <dd class="mb-4 text-steel-70">{{ t(stat.type) }}</dd>
            </div>
          }
        </dl>
      </section>

      @if (showActivity) {
        <div class="col-span-1">
          <rma-result-badges [badges]="agent.badges" [isPaying]="agent.hasMarketReports" />
          <rma-result-price-expectation [result]="agent.averagePriceExpectationResult" [shortName]="agent.shortName" />
        </div>
      }

      @if (agent.latestReviewsLoading) {
        <rma-skeleton [bones]="1" />
      }

      @if (agent.latestReviews && showActivity) {
        <div class="col-span-1 md:col-span-2 md:pt-4">
          <p class="mb-2 text-heading-3">{{ t('reviews-title') }}</p>
          <ng-scrollbar orientation="horizontal" trackClass="!bg-blue-10 !h-2" thumbClass="!bg-blue-50 !h-2">
            <rma-review-tile-list
              class="flex gap-6 [&>*]:w-[300px] [&>*]:min-w-[280px]"
              [reviews]="agent.latestReviews"
              [useHref]="true"
              profileType="Individual"
            />
            <div class="h-8"></div>
          </ng-scrollbar>
        </div>
      }

      <div class="col-span-1 hidden md:block"></div>
      @if (showActivity) {
        <div class="col-span-1 py-4 md:col-span-2">
          <rma-maps class="block" [agent]="agent" />
        </div>
      }

      <div class="col-span-1 md:col-start-2">
        <button type="button" (click)="onShowHideActivity(!showActivity)" mat-stroked-button color="primary">
          <div class="flex items-center space-x-2">
            <span>{{ t('activity.' + (showActivity ? 'hide' : 'show')) }}</span>
            <rma-icon [glyph]="showActivity ? 'expand_less' : 'expand_more'" />
          </div>
        </button>
      </div>

      <ng-container *ngTemplateOutlet="contactTemplate; context: { $implicit: 'flex gap-2 md:hidden' }" />
    </div>
  </div>

  <ng-template #contactTemplate let-class>
    <rma-result-contact
      [class]="class"
      [profileCode]="agent.profileCode"
      [isMobile]="agent.isMobile"
      [phone]="agent.phone"
      [name]="agent.shortName ?? agent.name"
      [email]="agent.email"
      [trixelUrl]="agent.profileConnectionTrixelUrl"
      [showMarketReport]="agent.hasMarketReports"
      [contactAnalytics]="agent.contactAnalytics"
      (contact)="contact.emit()"
    />
  </ng-template>
</ng-container>
